// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file pm/project_manager.proto (package vsmr.pm.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message vsmr.pm.v1.Project
 */
export class Project extends Message<Project> {
  /**
   * projects.id (uuid)
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * projects.user_id (uuid)
   *
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * projects.name — 원문(앞뒤 공백만 뗀 것). «같은 이름» 은 이름 키로 판정한다: 공백(JS \s 의 25자)을 전부 지우고
   * 소문자로 만든 값이 같으면 같은 이름이다. 프로젝트 이름은 **워크스페이스 안**에서 유일(겹치면 ALREADY_EXISTS —
   * CreateProject·UpdateProject·SetProjectWorkspace). 적합성 벡터 proto/pm/name_key_vectors.json, 구현 name_key.py.
   *
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * projects.description
   *
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * projects.data (jsonb serialized as string)
   *
   * @generated from field: string data_json = 5;
   */
  dataJson = "";

  /**
   * projects.created_at
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * projects.updated_at
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * projects.workspace_id (uuid) — 항상 채워진다(소속 없는 프로젝트는 없다, 0017)
   *
   * @generated from field: string workspace_id = 8;
   */
  workspaceId = "";

  constructor(data?: PartialMessage<Project>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.Project";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "data_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "updated_at", kind: "message", T: Timestamp },
    { no: 8, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Project {
    return new Project().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Project {
    return new Project().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Project {
    return new Project().fromJsonString(jsonString, options);
  }

  static equals(a: Project | PlainMessage<Project> | undefined, b: Project | PlainMessage<Project> | undefined): boolean {
    return proto3.util.equals(Project, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.CreateProjectRequest
 */
export class CreateProjectRequest extends Message<CreateProjectRequest> {
  /**
   * Required project id for cross-store ID consistency.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: string data_json = 5;
   */
  dataJson = "";

  /**
   * 생성 시 소속 워크스페이스 (빈 값 = 호출자의 기본 워크스페이스)
   *
   * @generated from field: string workspace_id = 6;
   */
  workspaceId = "";

  constructor(data?: PartialMessage<CreateProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.CreateProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "data_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectRequest {
    return new CreateProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectRequest {
    return new CreateProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectRequest {
    return new CreateProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectRequest | PlainMessage<CreateProjectRequest> | undefined, b: CreateProjectRequest | PlainMessage<CreateProjectRequest> | undefined): boolean {
    return proto3.util.equals(CreateProjectRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.CreateProjectResponse
 */
export class CreateProjectResponse extends Message<CreateProjectResponse> {
  /**
   * @generated from field: vsmr.pm.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<CreateProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.CreateProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateProjectResponse {
    return new CreateProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateProjectResponse {
    return new CreateProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateProjectResponse {
    return new CreateProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateProjectResponse | PlainMessage<CreateProjectResponse> | undefined, b: CreateProjectResponse | PlainMessage<CreateProjectResponse> | undefined): boolean {
    return proto3.util.equals(CreateProjectResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.GetProjectRequest
 */
export class GetProjectRequest extends Message<GetProjectRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.GetProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectRequest {
    return new GetProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectRequest {
    return new GetProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectRequest {
    return new GetProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectRequest | PlainMessage<GetProjectRequest> | undefined, b: GetProjectRequest | PlainMessage<GetProjectRequest> | undefined): boolean {
    return proto3.util.equals(GetProjectRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.GetProjectResponse
 */
export class GetProjectResponse extends Message<GetProjectResponse> {
  /**
   * @generated from field: vsmr.pm.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<GetProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.GetProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProjectResponse {
    return new GetProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProjectResponse {
    return new GetProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProjectResponse {
    return new GetProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProjectResponse | PlainMessage<GetProjectResponse> | undefined, b: GetProjectResponse | PlainMessage<GetProjectResponse> | undefined): boolean {
    return proto3.util.equals(GetProjectResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListProjectsRequest
 */
export class ListProjectsRequest extends Message<ListProjectsRequest> {
  /**
   * Optional filter by user_id.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListProjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListProjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectsRequest {
    return new ListProjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectsRequest {
    return new ListProjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectsRequest {
    return new ListProjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectsRequest | PlainMessage<ListProjectsRequest> | undefined, b: ListProjectsRequest | PlainMessage<ListProjectsRequest> | undefined): boolean {
    return proto3.util.equals(ListProjectsRequest, a, b);
  }
}

/**
 * 목록용 요약 — 본문(data_json)은 싣지 않는다. 카드가 보여 줄 개수는 서버가 jsonb 에서 센다.
 * 본문 전량을 실어 보내던 목록이 워크스페이스 전환마다 2.5MB·4.5초였다(스테이지 실측 2026-09-10, 게시판 #34).
 * 본문이 필요한 곳(프로젝트 열기·다른 프로젝트의 모델 복제)은 GetProject 로 그때 받는다.
 *
 * @generated from message vsmr.pm.v1.ProjectSummary
 */
export class ProjectSummary extends Message<ProjectSummary> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * 항상 채워진다(소속 없는 프로젝트는 없다)
   *
   * @generated from field: string workspace_id = 7;
   */
  workspaceId = "";

  /**
   * data.models 의 수
   *
   * @generated from field: int32 model_count = 8;
   */
  modelCount = 0;

  /**
   * 모든 모델의 nodes 합
   *
   * @generated from field: int32 node_count = 9;
   */
  nodeCount = 0;

  /**
   * 실행 기록(simulation_history) 수 — 서버가 실행 기록에서 센다(본문에서 파생하지 않는다)
   *
   * @generated from field: int32 simulation_count = 10;
   */
  simulationCount = 0;

  /**
   * 모델당 1항목(모델 순서 유지): 그 모델의 analysisCodes 를 '/' 로 이은 것. 비어 있는 모델은 제외
   *
   * @generated from field: repeated string analysis_codes = 11;
   */
  analysisCodes: string[] = [];

  constructor(data?: PartialMessage<ProjectSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ProjectSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
    { no: 7, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "model_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "node_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "simulation_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "analysis_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProjectSummary {
    return new ProjectSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProjectSummary {
    return new ProjectSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProjectSummary {
    return new ProjectSummary().fromJsonString(jsonString, options);
  }

  static equals(a: ProjectSummary | PlainMessage<ProjectSummary> | undefined, b: ProjectSummary | PlainMessage<ProjectSummary> | undefined): boolean {
    return proto3.util.equals(ProjectSummary, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListProjectsResponse
 */
export class ListProjectsResponse extends Message<ListProjectsResponse> {
  /**
   * @generated from field: repeated vsmr.pm.v1.ProjectSummary projects = 1;
   */
  projects: ProjectSummary[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListProjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListProjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "projects", kind: "message", T: ProjectSummary, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProjectsResponse {
    return new ListProjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProjectsResponse {
    return new ListProjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProjectsResponse {
    return new ListProjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListProjectsResponse | PlainMessage<ListProjectsResponse> | undefined, b: ListProjectsResponse | PlainMessage<ListProjectsResponse> | undefined): boolean {
    return proto3.util.equals(ListProjectsResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.UpdateProjectRequest
 */
export class UpdateProjectRequest extends Message<UpdateProjectRequest> {
  /**
   * Target project id.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Full replacement values for mutable fields.
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: string data_json = 4;
   */
  dataJson = "";

  constructor(data?: PartialMessage<UpdateProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.UpdateProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectRequest {
    return new UpdateProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectRequest {
    return new UpdateProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectRequest {
    return new UpdateProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectRequest | PlainMessage<UpdateProjectRequest> | undefined, b: UpdateProjectRequest | PlainMessage<UpdateProjectRequest> | undefined): boolean {
    return proto3.util.equals(UpdateProjectRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.UpdateProjectResponse
 */
export class UpdateProjectResponse extends Message<UpdateProjectResponse> {
  /**
   * @generated from field: vsmr.pm.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<UpdateProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.UpdateProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateProjectResponse {
    return new UpdateProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateProjectResponse {
    return new UpdateProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateProjectResponse {
    return new UpdateProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateProjectResponse | PlainMessage<UpdateProjectResponse> | undefined, b: UpdateProjectResponse | PlainMessage<UpdateProjectResponse> | undefined): boolean {
    return proto3.util.equals(UpdateProjectResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.DeleteProjectRequest
 */
export class DeleteProjectRequest extends Message<DeleteProjectRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * 스토리지에 파일이 남아 있어도 지울지. 기본(false)이면 지우지 않고 남은
   * 파일 수를 응답에 담아 돌려준다 — DB 레코드만 지우면 MinIO 의
   * {user_id}/{project_id}/ 객체가 고아로 남기 때문이다.
   *
   * @generated from field: bool force = 2;
   */
  force = false;

  constructor(data?: PartialMessage<DeleteProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.DeleteProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "force", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectRequest {
    return new DeleteProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectRequest {
    return new DeleteProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectRequest {
    return new DeleteProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectRequest | PlainMessage<DeleteProjectRequest> | undefined, b: DeleteProjectRequest | PlainMessage<DeleteProjectRequest> | undefined): boolean {
    return proto3.util.equals(DeleteProjectRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.DeleteProjectResponse
 */
export class DeleteProjectResponse extends Message<DeleteProjectResponse> {
  /**
   * 실제로 지웠는지. false 면 스토리지에 파일이 남아 거절한 것이다.
   * **호출자는 이 값을 반드시 확인해야 한다** — 예전처럼 예외가 아니라
   * 정상 응답이라, 안 보면 삭제되지 않은 것을 성공으로 오인한다.
   *
   * @generated from field: bool deleted = 1;
   */
  deleted = false;

  /**
   * deleted=false 일 때 남아 있던 파일 수. 사용자에게 규모를 보여주고
   * force 로 재요청할지 판단하게 하는 값이다.
   *
   * @generated from field: int32 remaining_files = 2;
   */
  remainingFiles = 0;

  /**
   * force 로 실제 지운 파일 수 (deleted=true 이고 파일이 있었을 때).
   *
   * @generated from field: int32 deleted_files = 3;
   */
  deletedFiles = 0;

  constructor(data?: PartialMessage<DeleteProjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.DeleteProjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "remaining_files", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "deleted_files", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteProjectResponse {
    return new DeleteProjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteProjectResponse {
    return new DeleteProjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteProjectResponse {
    return new DeleteProjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteProjectResponse | PlainMessage<DeleteProjectResponse> | undefined, b: DeleteProjectResponse | PlainMessage<DeleteProjectResponse> | undefined): boolean {
    return proto3.util.equals(DeleteProjectResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.SetProjectWorkspaceRequest
 */
export class SetProjectWorkspaceRequest extends Message<SetProjectWorkspaceRequest> {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * 이동할 워크스페이스 id. 빈 값이면 그 프로젝트 소유자의 기본 워크스페이스로.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  constructor(data?: PartialMessage<SetProjectWorkspaceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.SetProjectWorkspaceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetProjectWorkspaceRequest {
    return new SetProjectWorkspaceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetProjectWorkspaceRequest {
    return new SetProjectWorkspaceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetProjectWorkspaceRequest {
    return new SetProjectWorkspaceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetProjectWorkspaceRequest | PlainMessage<SetProjectWorkspaceRequest> | undefined, b: SetProjectWorkspaceRequest | PlainMessage<SetProjectWorkspaceRequest> | undefined): boolean {
    return proto3.util.equals(SetProjectWorkspaceRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.SetProjectWorkspaceResponse
 */
export class SetProjectWorkspaceResponse extends Message<SetProjectWorkspaceResponse> {
  /**
   * @generated from field: vsmr.pm.v1.Project project = 1;
   */
  project?: Project;

  constructor(data?: PartialMessage<SetProjectWorkspaceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.SetProjectWorkspaceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "message", T: Project },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetProjectWorkspaceResponse {
    return new SetProjectWorkspaceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetProjectWorkspaceResponse {
    return new SetProjectWorkspaceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetProjectWorkspaceResponse {
    return new SetProjectWorkspaceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetProjectWorkspaceResponse | PlainMessage<SetProjectWorkspaceResponse> | undefined, b: SetProjectWorkspaceResponse | PlainMessage<SetProjectWorkspaceResponse> | undefined): boolean {
    return proto3.util.equals(SetProjectWorkspaceResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.Workspace
 */
export class Workspace extends Message<Workspace> {
  /**
   * workspaces.id (uuid)
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * workspaces.user_id
   *
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * workspaces.name — 원문(앞뒤 공백만 뗀 것). **사용자 안**에서 이름 키(공백 전부 제거 + 소문자 — Project.name 과 같은
   * 규칙)가 유일(겹치면 ALREADY_EXISTS — CreateWorkspace·UpdateWorkspace).
   *
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * workspaces.description
   *
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * workspaces.created_at
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * workspaces.updated_at
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * workspaces.is_default — 사용자마다 하나. 워크스페이스를 고르지 않은 프로젝트가 속하고, 지울 수 없다.
   * 이름은 처음 이름(«기본 워크스페이스»)일 뿐 다른 행과 같이 바꿀 수 있다.
   *
   * @generated from field: bool is_default = 7;
   */
  isDefault = false;

  constructor(data?: PartialMessage<Workspace>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.Workspace";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
    { no: 7, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Workspace {
    return new Workspace().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Workspace {
    return new Workspace().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Workspace {
    return new Workspace().fromJsonString(jsonString, options);
  }

  static equals(a: Workspace | PlainMessage<Workspace> | undefined, b: Workspace | PlainMessage<Workspace> | undefined): boolean {
    return proto3.util.equals(Workspace, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.CreateWorkspaceRequest
 */
export class CreateWorkspaceRequest extends Message<CreateWorkspaceRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  constructor(data?: PartialMessage<CreateWorkspaceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.CreateWorkspaceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWorkspaceRequest {
    return new CreateWorkspaceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWorkspaceRequest {
    return new CreateWorkspaceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWorkspaceRequest {
    return new CreateWorkspaceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWorkspaceRequest | PlainMessage<CreateWorkspaceRequest> | undefined, b: CreateWorkspaceRequest | PlainMessage<CreateWorkspaceRequest> | undefined): boolean {
    return proto3.util.equals(CreateWorkspaceRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.CreateWorkspaceResponse
 */
export class CreateWorkspaceResponse extends Message<CreateWorkspaceResponse> {
  /**
   * @generated from field: vsmr.pm.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;

  constructor(data?: PartialMessage<CreateWorkspaceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.CreateWorkspaceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace", kind: "message", T: Workspace },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWorkspaceResponse {
    return new CreateWorkspaceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWorkspaceResponse {
    return new CreateWorkspaceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWorkspaceResponse {
    return new CreateWorkspaceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWorkspaceResponse | PlainMessage<CreateWorkspaceResponse> | undefined, b: CreateWorkspaceResponse | PlainMessage<CreateWorkspaceResponse> | undefined): boolean {
    return proto3.util.equals(CreateWorkspaceResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListWorkspacesRequest
 */
export class ListWorkspacesRequest extends Message<ListWorkspacesRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<ListWorkspacesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListWorkspacesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkspacesRequest {
    return new ListWorkspacesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkspacesRequest | PlainMessage<ListWorkspacesRequest> | undefined, b: ListWorkspacesRequest | PlainMessage<ListWorkspacesRequest> | undefined): boolean {
    return proto3.util.equals(ListWorkspacesRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListWorkspacesResponse
 */
export class ListWorkspacesResponse extends Message<ListWorkspacesResponse> {
  /**
   * @generated from field: repeated vsmr.pm.v1.Workspace workspaces = 1;
   */
  workspaces: Workspace[] = [];

  constructor(data?: PartialMessage<ListWorkspacesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListWorkspacesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspaces", kind: "message", T: Workspace, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWorkspacesResponse {
    return new ListWorkspacesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWorkspacesResponse | PlainMessage<ListWorkspacesResponse> | undefined, b: ListWorkspacesResponse | PlainMessage<ListWorkspacesResponse> | undefined): boolean {
    return proto3.util.equals(ListWorkspacesResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.UpdateWorkspaceRequest
 */
export class UpdateWorkspaceRequest extends Message<UpdateWorkspaceRequest> {
  /**
   * Target workspace id.
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * 소유자 검증용 — id가 다른 사용자 것이면 NOT_FOUND.
   *
   * @generated from field: string user_id = 2;
   */
  userId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  constructor(data?: PartialMessage<UpdateWorkspaceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.UpdateWorkspaceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWorkspaceRequest {
    return new UpdateWorkspaceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWorkspaceRequest {
    return new UpdateWorkspaceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWorkspaceRequest {
    return new UpdateWorkspaceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWorkspaceRequest | PlainMessage<UpdateWorkspaceRequest> | undefined, b: UpdateWorkspaceRequest | PlainMessage<UpdateWorkspaceRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWorkspaceRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.UpdateWorkspaceResponse
 */
export class UpdateWorkspaceResponse extends Message<UpdateWorkspaceResponse> {
  /**
   * @generated from field: vsmr.pm.v1.Workspace workspace = 1;
   */
  workspace?: Workspace;

  constructor(data?: PartialMessage<UpdateWorkspaceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.UpdateWorkspaceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace", kind: "message", T: Workspace },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWorkspaceResponse {
    return new UpdateWorkspaceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWorkspaceResponse {
    return new UpdateWorkspaceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWorkspaceResponse {
    return new UpdateWorkspaceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWorkspaceResponse | PlainMessage<UpdateWorkspaceResponse> | undefined, b: UpdateWorkspaceResponse | PlainMessage<UpdateWorkspaceResponse> | undefined): boolean {
    return proto3.util.equals(UpdateWorkspaceResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.DeleteWorkspaceRequest
 */
export class DeleteWorkspaceRequest extends Message<DeleteWorkspaceRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * 소유자 검증용 — id가 다른 사용자 것이면 NOT_FOUND.
   *
   * 소속 프로젝트는 삭제되지 않고 기본 워크스페이스로 옮겨진다. 기본 워크스페이스는 지울 수 없다.
   *
   * @generated from field: string user_id = 2;
   */
  userId = "";

  constructor(data?: PartialMessage<DeleteWorkspaceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.DeleteWorkspaceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWorkspaceRequest {
    return new DeleteWorkspaceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWorkspaceRequest {
    return new DeleteWorkspaceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWorkspaceRequest {
    return new DeleteWorkspaceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWorkspaceRequest | PlainMessage<DeleteWorkspaceRequest> | undefined, b: DeleteWorkspaceRequest | PlainMessage<DeleteWorkspaceRequest> | undefined): boolean {
    return proto3.util.equals(DeleteWorkspaceRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.SimulationHistory
 */
export class SimulationHistory extends Message<SimulationHistory> {
  /**
   * simulation_history.simulation_id (uuid)
   *
   * @generated from field: string simulation_id = 1;
   */
  simulationId = "";

  /**
   * simulation_history.project_id (uuid)
   *
   * @generated from field: string project_id = 2;
   */
  projectId = "";

  /**
   * simulation_history.title
   *
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * simulation_history.description
   *
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * simulation_history.start_time
   *
   * @generated from field: google.protobuf.Timestamp start_time = 5;
   */
  startTime?: Timestamp;

  /**
   * simulation_history.end_time
   *
   * @generated from field: google.protobuf.Timestamp end_time = 6;
   */
  endTime?: Timestamp;

  /**
   * simulation_history.cpu_time
   *
   * @generated from field: string cpu_time = 7;
   */
  cpuTime = "";

  /**
   * simulation_history.is_restart
   *
   * @generated from field: bool is_restart = 8;
   */
  isRestart = false;

  /**
   * simulation_history.status
   *
   * @generated from field: string status = 10;
   */
  status = "";

  /**
   * simulation_history.created_at
   *
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * simulation_history.updated_at
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * simulation_history.task_ids — 실행 태스크 ID 목록 (DB엔 CSV로 저장).
   * 이력 항목의 태스크 수/인덱스 해석 근거 (분석 뷰 멀티 모델 로드).
   *
   * @generated from field: repeated string task_ids = 13;
   */
  taskIds: string[] = [];

  /**
   * simulation_history.model_ids — 참가 모델 ID 목록 (DB엔 CSV로 저장).
   * task_ids와 같은 순서. 모델 홈의 "이 모델의 실행" 필터 근거.
   * 구 이력(귀속 미기록)은 빈 목록.
   *
   * @generated from field: repeated string model_ids = 14;
   */
  modelIds: string[] = [];

  /**
   * simulation_history.run_mode — 실행 모드: "cosim"(프로젝트 전 모델) |
   * "single"(TEST RUN 단독) | ""(구 이력 미기록)
   *
   * @generated from field: string run_mode = 15;
   */
  runMode = "";

  /**
   * simulation_history.project_name — 이력 생성 시점의 프로젝트 이름 스냅샷(프로젝트가 지워져도 남는다)
   *
   * @generated from field: string project_name = 16;
   */
  projectName = "";

  /**
   * simulation_history.participant_verdicts — 참가자(task_id)별 종결 판정
   * (completed|failed|stopped|terminated|unspecified). 실행 배지는 status 가, 결과 파일 유무는 참가자
   * 판정이 정한다(정지 핸드셰이크 설계 결정 2 — SM docs/stop-handshake-design.md). 구 이력은 빈 목록.
   *
   * @generated from field: repeated vsmr.pm.v1.ParticipantVerdict participants = 17;
   */
  participants: ParticipantVerdict[] = [];

  /**
   * simulation_history.participant_specs — 참가자(task_id)가 누구인지: 모델 id·이름·종별의 **시작 시점 스냅샷**.
   * 실행 기록이 스스로를 설명하기 위한 것 — 프로젝트가 지워져도 이어보기·결과 보기가 참가자를 이름으로 부른다.
   * task_ids 와 같은 참가자 집합. 구 이력(미기록)은 빈 목록.
   *
   * @generated from field: repeated vsmr.pm.v1.ParticipantSpec participant_specs = 18;
   */
  participantSpecs: ParticipantSpec[] = [];

  /**
   * simulation_history.scenario_id / scenario_name — 이 실행이 고른 시나리오(프로젝트 시나리오의 id·이름, 시작 시점
   * 스냅샷). 시작 요청 헤더(x-bff-scenario-id·x-bff-scenario-name)에서 적는다. 시나리오 없는 실행·구 이력은 빈 문자열.
   *
   * @generated from field: string scenario_id = 19;
   */
  scenarioId = "";

  /**
   * @generated from field: string scenario_name = 20;
   */
  scenarioName = "";

  constructor(data?: PartialMessage<SimulationHistory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.SimulationHistory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "simulation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "start_time", kind: "message", T: Timestamp },
    { no: 6, name: "end_time", kind: "message", T: Timestamp },
    { no: 7, name: "cpu_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "is_restart", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
    { no: 13, name: "task_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "model_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "run_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "project_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "participants", kind: "message", T: ParticipantVerdict, repeated: true },
    { no: 18, name: "participant_specs", kind: "message", T: ParticipantSpec, repeated: true },
    { no: 19, name: "scenario_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "scenario_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SimulationHistory {
    return new SimulationHistory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SimulationHistory {
    return new SimulationHistory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SimulationHistory {
    return new SimulationHistory().fromJsonString(jsonString, options);
  }

  static equals(a: SimulationHistory | PlainMessage<SimulationHistory> | undefined, b: SimulationHistory | PlainMessage<SimulationHistory> | undefined): boolean {
    return proto3.util.equals(SimulationHistory, a, b);
  }
}

/**
 * 참가자 하나의 신원 — Build 요청 헤더(x-bff-task-ids·model-ids·model-names·model-kinds, 동순)에서 적는다.
 *
 * @generated from message vsmr.pm.v1.ParticipantSpec
 */
export class ParticipantSpec extends Message<ParticipantSpec> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * @generated from field: string model_id = 2;
   */
  modelId = "";

  /**
   * 시작 시점의 모델 이름 — 프로젝트의 현재 이름이 아니다(개명·삭제와 무관한 기록)
   *
   * @generated from field: string model_name = 3;
   */
  modelName = "";

  /**
   * 참가 종별("mars" | "fmu" | …) — 화면이 어느 패널을 그릴지의 근거
   *
   * @generated from field: string kind = 4;
   */
  kind = "";

  constructor(data?: PartialMessage<ParticipantSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ParticipantSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParticipantSpec {
    return new ParticipantSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParticipantSpec {
    return new ParticipantSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParticipantSpec {
    return new ParticipantSpec().fromJsonString(jsonString, options);
  }

  static equals(a: ParticipantSpec | PlainMessage<ParticipantSpec> | undefined, b: ParticipantSpec | PlainMessage<ParticipantSpec> | undefined): boolean {
    return proto3.util.equals(ParticipantSpec, a, b);
  }
}

/**
 * 참가자 하나의 종결 판정 — SM 종결 저널 v3 의 participants 항목.
 *
 * @generated from message vsmr.pm.v1.ParticipantVerdict
 */
export class ParticipantVerdict extends Message<ParticipantVerdict> {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId = "";

  /**
   * @generated from field: string final_state = 2;
   */
  finalState = "";

  /**
   * 이 참가자가 왜 끝났는지 — 어댑터가 보고한 원문(SM 종결 저널의 participant_details).
   * 사유를 보고하지 않았거나 구 이력이면 빈 문자열이다.
   *
   * @generated from field: string detail = 3;
   */
  detail = "";

  constructor(data?: PartialMessage<ParticipantVerdict>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ParticipantVerdict";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "task_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "final_state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ParticipantVerdict {
    return new ParticipantVerdict().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ParticipantVerdict {
    return new ParticipantVerdict().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ParticipantVerdict {
    return new ParticipantVerdict().fromJsonString(jsonString, options);
  }

  static equals(a: ParticipantVerdict | PlainMessage<ParticipantVerdict> | undefined, b: ParticipantVerdict | PlainMessage<ParticipantVerdict> | undefined): boolean {
    return proto3.util.equals(ParticipantVerdict, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.GetSimulationHistoryRequest
 */
export class GetSimulationHistoryRequest extends Message<GetSimulationHistoryRequest> {
  /**
   * @generated from field: string simulation_id = 1;
   */
  simulationId = "";

  constructor(data?: PartialMessage<GetSimulationHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.GetSimulationHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "simulation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSimulationHistoryRequest {
    return new GetSimulationHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSimulationHistoryRequest {
    return new GetSimulationHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSimulationHistoryRequest {
    return new GetSimulationHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSimulationHistoryRequest | PlainMessage<GetSimulationHistoryRequest> | undefined, b: GetSimulationHistoryRequest | PlainMessage<GetSimulationHistoryRequest> | undefined): boolean {
    return proto3.util.equals(GetSimulationHistoryRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.GetSimulationHistoryResponse
 */
export class GetSimulationHistoryResponse extends Message<GetSimulationHistoryResponse> {
  /**
   * @generated from field: vsmr.pm.v1.SimulationHistory simulation_history = 1;
   */
  simulationHistory?: SimulationHistory;

  constructor(data?: PartialMessage<GetSimulationHistoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.GetSimulationHistoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "simulation_history", kind: "message", T: SimulationHistory },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSimulationHistoryResponse {
    return new GetSimulationHistoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSimulationHistoryResponse {
    return new GetSimulationHistoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSimulationHistoryResponse {
    return new GetSimulationHistoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSimulationHistoryResponse | PlainMessage<GetSimulationHistoryResponse> | undefined, b: GetSimulationHistoryResponse | PlainMessage<GetSimulationHistoryResponse> | undefined): boolean {
    return proto3.util.equals(GetSimulationHistoryResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListSimulationHistoriesRequest
 */
export class ListSimulationHistoriesRequest extends Message<ListSimulationHistoriesRequest> {
  /**
   * Optional filter by project_id.
   *
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListSimulationHistoriesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListSimulationHistoriesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSimulationHistoriesRequest {
    return new ListSimulationHistoriesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSimulationHistoriesRequest {
    return new ListSimulationHistoriesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSimulationHistoriesRequest {
    return new ListSimulationHistoriesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSimulationHistoriesRequest | PlainMessage<ListSimulationHistoriesRequest> | undefined, b: ListSimulationHistoriesRequest | PlainMessage<ListSimulationHistoriesRequest> | undefined): boolean {
    return proto3.util.equals(ListSimulationHistoriesRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListSimulationHistoriesResponse
 */
export class ListSimulationHistoriesResponse extends Message<ListSimulationHistoriesResponse> {
  /**
   * @generated from field: repeated vsmr.pm.v1.SimulationHistory simulation_histories = 1;
   */
  simulationHistories: SimulationHistory[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListSimulationHistoriesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListSimulationHistoriesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "simulation_histories", kind: "message", T: SimulationHistory, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSimulationHistoriesResponse {
    return new ListSimulationHistoriesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSimulationHistoriesResponse {
    return new ListSimulationHistoriesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSimulationHistoriesResponse {
    return new ListSimulationHistoriesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSimulationHistoriesResponse | PlainMessage<ListSimulationHistoriesResponse> | undefined, b: ListSimulationHistoriesResponse | PlainMessage<ListSimulationHistoriesResponse> | undefined): boolean {
    return proto3.util.equals(ListSimulationHistoriesResponse, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.DeleteSimulationHistoryRequest
 */
export class DeleteSimulationHistoryRequest extends Message<DeleteSimulationHistoryRequest> {
  /**
   * @generated from field: string simulation_id = 1;
   */
  simulationId = "";

  constructor(data?: PartialMessage<DeleteSimulationHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.DeleteSimulationHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "simulation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteSimulationHistoryRequest {
    return new DeleteSimulationHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteSimulationHistoryRequest {
    return new DeleteSimulationHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteSimulationHistoryRequest {
    return new DeleteSimulationHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteSimulationHistoryRequest | PlainMessage<DeleteSimulationHistoryRequest> | undefined, b: DeleteSimulationHistoryRequest | PlainMessage<DeleteSimulationHistoryRequest> | undefined): boolean {
    return proto3.util.equals(DeleteSimulationHistoryRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListSimulationHistoriesByUserRequest
 */
export class ListSimulationHistoriesByUserRequest extends Message<ListSimulationHistoriesByUserRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListSimulationHistoriesByUserRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListSimulationHistoriesByUserRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSimulationHistoriesByUserRequest {
    return new ListSimulationHistoriesByUserRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSimulationHistoriesByUserRequest {
    return new ListSimulationHistoriesByUserRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSimulationHistoriesByUserRequest {
    return new ListSimulationHistoriesByUserRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSimulationHistoriesByUserRequest | PlainMessage<ListSimulationHistoriesByUserRequest> | undefined, b: ListSimulationHistoriesByUserRequest | PlainMessage<ListSimulationHistoriesByUserRequest> | undefined): boolean {
    return proto3.util.equals(ListSimulationHistoriesByUserRequest, a, b);
  }
}

/**
 * @generated from message vsmr.pm.v1.ListSimulationHistoriesByProjectRequest
 */
export class ListSimulationHistoriesByProjectRequest extends Message<ListSimulationHistoriesByProjectRequest> {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId = "";

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken = "";

  constructor(data?: PartialMessage<ListSimulationHistoriesByProjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.pm.v1.ListSimulationHistoriesByProjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSimulationHistoriesByProjectRequest {
    return new ListSimulationHistoriesByProjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSimulationHistoriesByProjectRequest {
    return new ListSimulationHistoriesByProjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSimulationHistoriesByProjectRequest {
    return new ListSimulationHistoriesByProjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSimulationHistoriesByProjectRequest | PlainMessage<ListSimulationHistoriesByProjectRequest> | undefined, b: ListSimulationHistoriesByProjectRequest | PlainMessage<ListSimulationHistoriesByProjectRequest> | undefined): boolean {
    return proto3.util.equals(ListSimulationHistoriesByProjectRequest, a, b);
  }
}

